import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import "./SignInPage.scss";
import OrangeBtn from "../../Reuseable/OrangeBtn/OrangeBtn";
import PasswordInput from "../../Reuseable/PasswordInput/PasswordInput";
import FormInput from "../../Reuseable/FormInput/FormInput";
import { loginUser } from "../../store/auth";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

const SignInSchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Email is required"),

  password: Yup.string()
    .required("Password is required")
    .min(8, "Password must be at least 8 characters"),
});

const SignInPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  return (
    <div className="signinPageMain">
      <div
        style={{
          maxWidth: "600px",
          width: "100%",
          padding: "20px",
          border: "1px solid #ccc",
          borderRadius: "20px",
        }}
      >
        <h2 className="title_">Sign In</h2>
        <Formik
          initialValues={{ email: "", password: "" }}
          validationSchema={SignInSchema}
          onSubmit={async (values, { setSubmitting, setErrors }) => {
            try {
              const result = await dispatch(
                loginUser({
                  email: values.email,
                  password: values.password,
                })
              );
            
              if (result?.payload?.idToken) {
                toast.success("Login successful");
                navigate("/dashboard");
              }
              else {
                toast.error(result?.payload?.data?.detail);
             
              }
            } catch (error) {
              // setErrors({ password: "Invalid email or password" });
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ handleSubmit, isSubmitting }) => (
            <form className="formWrapper" onSubmit={handleSubmit}>
              <div className="basicDetail">
                <div className="detailBox">
                  <h2>Enter your E-mail</h2>
                  <FormInput
                    name="email"
                    label="Email"
                    type="email"
                    placeholder="Enter your email"
                  />
                </div>
                <div className="detailBox">
                  <h2>Enter your Password</h2>
                  <PasswordInput
                    name="password"
                    label="Password"
                    type="password"
                  />
                </div>
              </div>

              <OrangeBtn
                loading={isSubmitting}
                type="submit"
                text="Submit"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                Sign In
              </OrangeBtn>
            </form>
          )}
        </Formik>
      </div>
                 <Toaster position="top-center" reverseOrder={false} />
    </div>
  );
};

export default SignInPage;
